module.exports = __webpack_public_path__ + "img/markerPurple.d9415180.svg";